module.exports = __webpack_public_path__ + "static/a-couple-looking-at-tablet-with-advisor.c327ab2f.webp";